'use strict';

var React = require('react');

var SvgQuestionMarkInverseMajor = function SvgQuestionMarkInverseMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-7.071.929a10 10 0 1 1 14.141 14.141 10 10 0 0 1-14.14-14.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.126 13.002h-2.136v-1.142c.01-1.966.492-2.254 1.374-2.782.093-.056.19-.114.293-.178.73-.459 1.292-1.038 1.292-1.883 0-.948-.743-1.564-1.666-1.564-.852 0-1.657.398-1.712 1.533h-2.266c.06-2.294 1.877-3.487 3.99-3.487 2.306 0 3.894 1.447 3.894 3.488 0 1.382-.695 2.288-1.806 2.952l-.237.144c-.79.475-1.009.607-1.02 1.777v1.142zm.17 2.012a1.344 1.344 0 0 1-1.327 1.328 1.32 1.32 0 0 1-1.227-1.834 1.318 1.318 0 0 1 1.227-.81c.712 0 1.322.592 1.328 1.316h-.001z"
  }));
};

exports.SvgQuestionMarkInverseMajor = SvgQuestionMarkInverseMajor;
